import { render, staticRenderFns } from "./HomeConsumptionstructure.vue?vue&type=template&id=6ea134ed&scoped=true&"
import script from "./HomeConsumptionstructure.vue?vue&type=script&lang=js&"
export * from "./HomeConsumptionstructure.vue?vue&type=script&lang=js&"
import style0 from "./HomeConsumptionstructure.vue?vue&type=style&index=0&id=6ea134ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea134ed",
  null
  
)

export default component.exports